import React, { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import {
  Button,
  Switch,
  FormControlLabel,
  InputAdornment,
  IconButton,
  Icon,
  Typography,
} from "@mui/material";
import {
  authServiceInstance,
  applicationTitle,
  loginImage,
  loginTitle,
  loginDivStyle,
  loginTextStyle,
  appTitles,
  loginImageStyle,
  loginBoxStyle,
  setGlobalDrawerWidth,
  showCaptcha,
  showCustomUnAuthPage,
  showJobIdInput,
  captchaSiteKey,
} from "../General/globals";
import { offlineLayoutInfo } from "../General/globals";
// import store from "../AppRedux/store";
import { showAppBusy, hideAppBusy } from "../AppOwnState";
import { ShowSnackBar } from "../General/globalFunctions";
import { ownStore } from "../AppOwnState/ownState";
import { ExecuteLayoutEventMethods } from "../General/commonFunctions";
import AccountCircle from "@mui/icons-material/AccountCircle";
import Grid3x3Icon from "@mui/icons-material/Grid3x3";
import LockIcon from "@mui/icons-material/Lock";
import PureJSComponentFactory from "./Pages/Factory/pureJSComponentFactory";
import ReCaptcha from "./captcha/Captcha";

class LoginComponent extends Component {
  constructor(props) {
    super(props);
    this.validateCaptcha = false;
    this.state = {
      loginName: "",
      password: "",
      jobId: null,
      rememberMe: false,
      pwdPlainText: false,
      captcha: null,
      validateReCaptcha: false,
    };
    document.title = applicationTitle;
    setGlobalDrawerWidth(0);
    this.loginFooter = new PureJSComponentFactory().scaffoldComponent(
      offlineLayoutInfo?.loginfooter
    );
    this.loginSplitImage = new PureJSComponentFactory().scaffoldComponent(
      offlineLayoutInfo?.loginsplitimage
    );
  }

  async showCaptcha() {
    try {
      const response = await fetch("/init.json");
      let jsonData;
      if (response) {
        jsonData = await response.json();
        if (jsonData?.service?.authbody?.reCaptcha) {
          this.setState({
            validateReCaptcha: jsonData?.service?.authbody?.reCaptcha,
          });
        } else {
          this.setState({ validateReCaptcha: false });
        }
      }
    } catch (error) {
      console.error("Error fetching captcha:", error);
    }
  }

  componentDidMount() {
    this.showCaptcha();
    if (this.props.sessionOut) {
      this.setState({
        loginName: this.props.authEmail,
      });
    }
  }

  getCaptcha(data) {
    const captchaValue = data ? true : false;
    this.setState({
      captcha: captchaValue,
    });
  }

  handleInputChange(e) {
    let stateValue = e.target.value;
    if (e.target.type === "checkbox") {
      stateValue = e.target.checked;
    }
    this.setState({
      [e.target.id]: stateValue,
    });
  }

  async doSignIn(e) {
    e.preventDefault();
    if (this.state.validateReCaptcha && !this.state.captcha) {
      alert("Please verify the reCAPTCHA!");
      return;
    }

    try {
      ownStore.dispatch(showAppBusy());
      if (this.state.password.trim() === "") {
        ShowSnackBar("error", "Password cannot be empty!");
        ownStore.dispatch(hideAppBusy());
        return;
      }
      await authServiceInstance.login(
        this.state.loginName,
        this.state.password,
        this.state.rememberMe,
        this.state.jobId
      );
      let authOK = await authServiceInstance.verifyLogin();
      if (authOK?.status) {
        // window.location.href = '#/'
        if (authOK?.doNext) {
          ownStore.dispatch(hideAppBusy());
          try {
            let authEvents = JSON.parse(authOK.doNext);
            await ExecuteLayoutEventMethods(authEvents);
          } catch {}
          return;
        }
        authServiceInstance.continueLogin();
        return;
      }
    } catch (ex) {
      console.error(ex);
    }
    ownStore.dispatch(hideAppBusy()); //Hide loader if the authentication failed with an errorx

    ShowSnackBar("error", "Login Failed!");
  }

  render() {
    if (showCustomUnAuthPage) {
      return (
        <form onSubmit={this.doSignIn.bind(this)}>
          <Card className="login-card" variant="outlined" style={loginBoxStyle}>
            {showJobIdInput && (
              <Grid item xs={12} className="JobIdGrid">
                <TextField
                  id="jobId"
                  className="jobIdTextfiled"
                  label={appTitles?.jobId ?? "Job ID"}
                  variant="outlined"
                  size="small"
                  disabled={this.props.sessionOut || false}
                  autoComplete="off"
                  onChange={this.handleInputChange.bind(this)}
                  InputProps={{
                    style: { backgroundColor: "white", borderRadius: "5px" },
                    startAdornment: (
                      <InputAdornment position="start">
                        <Grid3x3Icon />
                      </InputAdornment>
                    ),
                  }}
                  value={this.state.jobId || ""}
                  fullWidth
                />
              </Grid>
            )}
            <Grid item xs={12} className="loginNameGrid">
              <TextField
                id="loginName"
                className="loginNameTextfiled"
                label={appTitles?.loginname ?? "Username"}
                variant="outlined"
                size="small"
                disabled={this.props.sessionOut || false}
                autoComplete="off"
                onChange={this.handleInputChange.bind(this)}
                InputProps={{
                  style: { backgroundColor: "white", borderRadius: "5px" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <AccountCircle />
                    </InputAdornment>
                  ),
                }}
                value={this.state.loginName}
                fullWidth
              />
            </Grid>
            <Grid item xs={12} className="passwordGrid">
              <TextField
                id="password"
                className="paswwordTextfield"
                label={appTitles?.password ?? "Password"}
                variant="outlined"
                size="small"
                autoComplete="off"
                onChange={this.handleInputChange.bind(this)}
                value={this.state.password}
                type={this.state.pwdPlainText ? "text" : "password"}
                fullWidth
                InputProps={{
                  style: { backgroundColor: "white", borderRadius: "5px" },
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        size="small"
                        onClick={() =>
                          this.setState({
                            pwdPlainText: !this.state.pwdPlainText,
                          })
                        }
                      >
                        <Icon>
                          {this.state.pwdPlainText
                            ? "visibility_off"
                            : "visibility"}
                        </Icon>
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item xs={6} className="rememberMeGrid">
              <FormControlLabel
                control={
                  <Switch
                    id="rememberMe"
                    className="rememberMeSwitch"
                    checked={this.state.rememberMe}
                    onChange={this.handleInputChange.bind(this)}
                  />
                }
                label={
                  <Typography
                    style={{ fontSize: "0.8rem", fontWeight: "bold" }}
                    className="rememberMeTypo"
                  >
                    {appTitles?.rememberme ?? "Remember Me"}
                  </Typography>
                }
              />
            </Grid>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              {this.state.validateReCaptcha && (
                <ReCaptcha
                  getCaptcha={this.getCaptcha.bind(this)}
                  sitekey={captchaSiteKey || ""}
                />
              )}
            </div>

            {/* <Grid item xs={6} className="signinGrid"> */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                marginTop: "15px",
              }}
            >
              <Button
                type="submit"
                variant="contained"
                size="medium"
                color="primary"
                className="signinButtonClass"
                fullWidth
              >
                {appTitles?.loginbutton ?? "Sign In"}
              </Button>
            </div>

            {this.loginFooter && (
              <Grid item xs={12} className="loginFooterClass">
                {this.loginFooter}
              </Grid>
            )}
          </Card>
        </form>
      );
    } else
      return (
        <form onSubmit={this.doSignIn.bind(this)}>
          <Card className="login-card" variant="outlined" style={loginBoxStyle}>
            <CardContent className="loginCard">
              <Grid container spacing={3} className="loginCardGrid">
                <Grid item xs={12} className="login-head" style={loginDivStyle}>
                  {loginImage && (
                    <img
                      style={{ height: "100px", ...loginImageStyle }}
                      src={loginImage}
                      alt="Logo"
                      className="logoImageClass"
                    />
                  )}
                  {loginTitle && <h2 style={loginTextStyle}>{loginTitle}</h2>}
                </Grid>
                {showJobIdInput && (
                  <Grid item xs={12} className="JobIdGrid">
                    <TextField
                      id="jobId"
                      className="jobIdTextfiled"
                      label={appTitles?.jobId ?? "Job ID"}
                      variant="outlined"
                      size="small"
                      disabled={this.props.sessionOut || false}
                      autoComplete="off"
                      onChange={this.handleInputChange.bind(this)}
                      InputProps={{
                        style: {
                          backgroundColor: "white",
                          borderRadius: "5px",
                        },
                        startAdornment: (
                          <InputAdornment position="start">
                            <Grid3x3Icon />
                          </InputAdornment>
                        ),
                      }}
                      value={this.state.jobId || ""}
                      fullWidth
                    />
                  </Grid>
                )}

                <Grid item xs={12} className="loginNameGrid">
                  <TextField
                    id="loginName"
                    className="loginNameTextfiled"
                    label={appTitles?.loginname ?? "Username"}
                    variant="outlined"
                    size="small"
                    disabled={this.props.sessionOut || false}
                    autoComplete="off"
                    onChange={this.handleInputChange.bind(this)}
                    InputProps={{
                      style: { backgroundColor: "white", borderRadius: "5px" },
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle />
                        </InputAdornment>
                      ),
                    }}
                    value={this.state.loginName}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} className="passwordGrid">
                  <TextField
                    id="password"
                    className="paswwordTextfield"
                    label={appTitles?.password ?? "Password"}
                    variant="outlined"
                    size="small"
                    autoComplete="off"
                    onChange={this.handleInputChange.bind(this)}
                    value={this.state.password}
                    type={this.state.pwdPlainText ? "text" : "password"}
                    fullWidth
                    InputProps={{
                      style: { backgroundColor: "white", borderRadius: "5px" },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            size="small"
                            onClick={() =>
                              this.setState({
                                pwdPlainText: !this.state.pwdPlainText,
                              })
                            }
                          >
                            <Icon>
                              {this.state.pwdPlainText
                                ? "visibility_off"
                                : "visibility"}
                            </Icon>
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={6} className="rememberMeGrid">
                  <FormControlLabel
                    control={
                      <Switch
                        id="rememberMe"
                        className="rememberMeSwitch"
                        checked={this.state.rememberMe}
                        onChange={this.handleInputChange.bind(this)}
                      />
                    }
                    label={
                      <Typography
                        style={{ fontSize: "0.8rem", fontWeight: "bold" }}
                        className="rememberMeTypo"
                      >
                        {appTitles?.rememberme ?? "Remember Me"}
                      </Typography>
                    }
                  />
                </Grid>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  {this.state.validateReCaptcha && (
                    <ReCaptcha
                      getCaptcha={this.getCaptcha.bind(this)}
                      sitekey={captchaSiteKey || ""}
                    />
                  )}
                </div>

                {/* <Grid item xs={6} className="signinGrid"> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                    marginTop: "15px",
                  }}
                >
                  <Button
                    type="submit"
                    variant="contained"
                    size="medium"
                    color="primary"
                    className="signinButtonClass"
                    fullWidth
                  >
                    {appTitles?.loginbutton ?? "Sign In"}
                  </Button>
                </div>

                {this.loginFooter && (
                  <Grid item xs={12} className="loginFooterClass">
                    {this.loginFooter}
                  </Grid>
                )}
              </Grid>
            </CardContent>
          </Card>
        </form>
      );
  }
}

export default LoginComponent;
